const m = require('air-vue-model')()
m.url = 'display_lines'
m.name = 'displayLine'

m.text = {
    listTitle: 'Очереди',
    itemTitle: 'Очередь',
}

m.default = {
    name: null,
    items: []
}

m.setPagination({
    page_size: 100
})

m.pk = 'uuid'

m.routes = [
    {
        name: 'list',
        component: require('@/admin/views/display/lines/DisplayLines'),
    },
    {
        name: 'item',
        component: require('@/admin/views/display/lines/DisplayLine'),
        single: true
    },
]

module.exports = m